import FormFooter from 'components/organisms/Form/FormFooter/FormFooter'
import React, { Component } from 'react'
import { Col, Row } from 'react-bootstrap'
import { connect } from 'react-redux'
import { NavLink } from 'react-router-dom'
import * as FormConst from '../../../../constants/FormConst'
import RouteConst from '../../../../constants/RouteConst'
import SessionConst from '../../../../constants/SessionConst'
import SideNavEntryMapping from '../../../../constants/SideNavEntryMapping'
import { asyncMethod } from '../../../../redux/actions'
import * as actionTypes from '../../../../redux/actionTypes'
import MeetingRoomsService from '../../../../services/MeetingRoomsService'
import {isArrayNotEmpty, isCompletedHotelInfoHistory, isHotelDomestic} from '../../../../utilities/JSUtil'
import { getSessionItem } from '../../../../utilities/SessionHelper'
import Card from '../../../molecules/Card/Card'
import MultiCard from '../../../molecules/Card/MultiCard'
import FormModal from '../../../organisms/FormModal/FormModal'
import withFormLayout from '../WithFormLayout'
import './MeetingRooms.scss'

class MeetingRooms extends Component {

  constructor(props) {
    super(props)
    const hotelCode = getSessionItem(SessionConst.HOTEL_CODE)
    const hotelInfo = getSessionItem(SessionConst.HOTEL_INFO)
    let hotelInfoCompletedHistory = getSessionItem(SessionConst.HOTEL_INFO_COMPLETED_HISTORY)

    if (!hotelCode || !hotelInfo) {
      this.props.history.replace(RouteConst.ROUTE_HOME_PAGE)
    }

    const isDomestic = isHotelDomestic(hotelInfo)

    this.addMeetingRoom = this.addMeetingRoom.bind(this)
    this.deleteMeetingRoom = this.deleteMeetingRoom.bind(this)
    this.handleDelete = this.handleDelete.bind(this)

    this.state = {
      hotelCode: hotelCode,
      hotelInfo: hotelInfo,
      isHotelDomestic: isDomestic,
      lengthUnit: getSessionItem(SessionConst.LENGTH_UNIT),
      areaUnits: getSessionItem(SessionConst.AREA_UNIT),
      isLoading: true,
      loadingMessage: FormConst.MODAL_READ_ACTION_TEXT,
      showDeleteModal: false,
      deleteIndex: -1,
      showErrorModal: false,
      hotelInfoCompletedHistory: hotelInfoCompletedHistory
    }
  }

  async componentDidMount() {
    if (isCompletedHotelInfoHistory(this.state.hotelInfoCompletedHistory)) {
      let meetingRoomsFromSession = this.state.hotelInfoCompletedHistory.newEntity.meetingRooms
      this.setState({
        meetingRooms: meetingRoomsFromSession.meetingRooms || [],
        meetingRoomInfo: meetingRoomsFromSession.meetingRoomInfo,
        totalArea: this.calculateTotalAreaOfMeetingRooms(meetingRoomsFromSession.meetingRooms || []),
        isLoading: false
      })
   } else {
    await MeetingRoomsService.getMeetingRooms({ hotelCode: this.state.hotelCode })
      .then(response => {
        this.setState({
          meetingRooms: response.meetingRooms || [],
          meetingRoomInfo: response.meetingRoomInfo,
          totalArea: this.calculateTotalAreaOfMeetingRooms(response.meetingRooms || []),
          isLoading: false
        })
      })
      .catch(error => {
        this.setState({
          isLoading: false,
          showErrorModal: true,
          errorMessage: 'There was an error while reading Meeting Rooms data'
        })
      })
    }
  }

  /**
   * Calculates the totalArea based on the dimension area of all the available meeting rooms for
   * the property
   * @param meetingRooms
   * @returns Number totalArea of the meeting rooms
   */
  calculateTotalAreaOfMeetingRooms = (meetingRooms) => {
    return meetingRooms.reduce((sum, currentMeetingRoom) =>
                                   sum + (currentMeetingRoom.dimension.area.value || (currentMeetingRoom.dimension.length*currentMeetingRoom.dimension.width)), 0);
  }

  saveMeetingRooms = () => {
    if (isArrayNotEmpty(this.state.meetingRooms)) {
      this.proceedToNextSection()
    } else {
      let meetingRooms = []
      this.props.onPut({ hotelCode: this.state.hotelCode, meetingRooms: meetingRooms })
      this.setState({
        pendingMeetingRooms: meetingRooms,
        isLoading: true,
        loadingMessage: FormConst.MODAL_UPDATE_ACTION_TEXT,
        showDeleteModal: false,
        actionPerformed: FormConst.ACTION_SAVE_AND_PROCEED
      })
    }
  }

  addMeetingRoom = () => {
    this.props.history.push(RouteConst.ROUTE_MEETING_ROOM_PAGE, {
      meetingRooms: this.state.meetingRooms && this.state.meetingRooms.length > 0 ? [...this.state.meetingRooms] : []
    })
  }

  deleteMeetingRoom = () => {

    let meetingRooms = [...this.state.meetingRooms]
    meetingRooms.splice(this.state.deleteIndex, 1)

    this.props.onPut({ hotelCode: this.state.hotelCode, meetingRooms: meetingRooms })

    this.setState({
      pendingMeetingRooms: meetingRooms,
      totalArea: this.calculateTotalAreaOfMeetingRooms(meetingRooms || []),
      isLoading: true,
      loadingMessage: FormConst.MODAL_UPDATE_ACTION_TEXT,
      showDeleteModal: false,
      actionPerformed: FormConst.ACTION_PUT
    })
  }

  handleDelete = (index) => {
    this.setState({
      showDeleteModal: true,
      deleteIndex: index
    })
  }

  componentDidUpdate(prevProps) {
    if (prevProps.count !== this.props.count) {
      if (this.props.errorMessage) {
        this.setState({
          isLoading: false,
          pendingMeetingRooms: undefined,
          showErrorModal: true,
          errorMessage: this.props.errorDescription
        })
      } else {
        // Get service response again for updated General Meeting Room Info
        if (this.state.actionPerformed === FormConst.ACTION_PUT) {
          this.props.onGet(this.state.hotelCode)
          this.setState({
            isLoading: true,
            meetingRooms: this.state.pendingMeetingRooms,
            pendingMeetingRooms: undefined,
            actionPerformed: undefined
          })
        } else if (this.state.actionPerformed === FormConst.ACTION_SAVE_AND_PROCEED) {
          this.proceedToNextSection()
        } else {
          // Update state for GET
          this.setState({
            isLoading: false,
            meetingRooms: this.props.meetingRoomsResponse.meetingRooms || [],
            meetingRoomInfo: this.props.meetingRoomsResponse.meetingRoomInfo,
            pendingMeetingRooms: undefined,
            actionPerformed: undefined
          })
        }
      }
    }
  }

  proceedToNextSection = () => {
    this.props.history.push(RouteConst.ROUTE_INVENTORY_CLOSEOUTS_PAGE)
  }

  render() {
    // Build individual meeting rooms cards
    let individualMeetingRoomsCardsData

    const areMeetingRoomsPresent = isArrayNotEmpty(this.state.meetingRooms)

    if (areMeetingRoomsPresent) {
      individualMeetingRoomsCardsData = this.state.meetingRooms.map((meetingRoom, index) => {

        let meetingRoomCardText = <>
          <dl className='inline-list'>
            <dt>Length</dt>
            <dd>{meetingRoom.dimension.length + ' ' + this.state.lengthUnit}</dd>
            <dt>Width</dt>
            <dd>{meetingRoom.dimension.width + ' ' + this.state.lengthUnit}</dd>
            <dt>Height</dt>
            <dd>{meetingRoom.dimension.height + ' ' + this.state.lengthUnit}</dd>
            {meetingRoom.dimension.area &&
              <>
                <dt>Total Area</dt>
                <dd>{(meetingRoom.dimension.length*meetingRoom.dimension.width) + ' ' + this.state.areaUnits}</dd>
                <dt>Available Total Area</dt>
                <dd>{meetingRoom.dimension.area.value + ' ' + this.state.areaUnits}</dd>
              </>
            }

          </dl>
          <dl className='inline-list-separator'></dl>
          <dl className='inline-list'>
            <dt>Configurations Available</dt>
            {meetingRoom.configurations && meetingRoom.configurations.length > 0
             ?  <dd>{meetingRoom.configurations.map(config => config.name).join(', ')}</dd>
             :  <dd className='text-red'>No configurations specified</dd>
            }
          </dl>

        </>

        let meetingRoomCardActions = [{
          'onClick': () => this.props.history.push(RouteConst.ROUTE_MEETING_ROOM_PAGE, {
            isEdit: true,
            editIndex: index,
            meetingRoom: meetingRoom,
            meetingRooms: [...this.state.meetingRooms]
          }),
          'label': 'Edit'
        },
        {
          'onClick': () => this.handleDelete(index),
          'label': 'Delete'
        }]

        return {
          id: `meeting-room-card-${index}`,
          title: meetingRoom.name,
          text: meetingRoomCardText,
          actions: meetingRoomCardActions
        }
      })

    }

    return (
      <div className='meeting-rooms-page'>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><NavLink to='/'>Home</NavLink></li>
            <li className="breadcrumb-item active" aria-current="page">Meeting Rooms</li>
          </ol>
        </nav>
        {/* Helper text */}
        <p className='helper-text'>{FormConst.MEETING_ROOMS_HELPER_TEXT}</p>
        {/* Show meeting rooms info card */}
        {
          this.state.meetingRoomInfo
            ? (
              <div className='meeting-room-info-card'>
                <Card
                  id='meeting-rooms-info-card'
                  header='General Meeting Room Information'
                  text={(
                      <div>
                        <Row className='d-flex align-items-center'>
                          <Col xs={12} sm={12} md={12} lg={4} xl={4}>
                            <dt>Total Meeting Rooms</dt>
                            <dd>{this.state.meetingRooms.length}</dd>
                          </Col>
                          <Col xs={12} sm={12} md={12} lg={4} xl={4}>
                            <dt>Maximum Banquet Capacity</dt>
                            <dd>{this.state.meetingRoomInfo.maximumBanquetCapacity}</dd>
                          </Col>
                          <Col xs={12} sm={12} md={12} lg={4} xl={4}>
                            <dt>Maximum Conference Capacity</dt>
                            <dd>{this.state.meetingRoomInfo.maximumConferenceCapacity}</dd>
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={12} sm={12} md={12} lg={4} xl={4}>
                            <dt>Total Meeting Rooms Area</dt>
                            <dd>{this.state.totalArea +' '+this.state.areaUnits}</dd>
                          </Col>
                        </Row>
                      </div>
                  )}
                  isFill />
              </div>)
            : (
              <div className='meeting-room-info-card'>
                <Card
                  id='meeting-rooms-info-card'
                  header='Meeting Rooms Info'
                  title='No information available'
                  className='meeting-room-info-card' />
              </div>)
        }

        {/* Show individual meeting room cards */}
        <div className='individual-meeting-room-cards'>
          <MultiCard
            id='individual-meeting-room-card'
            header='Meeting Rooms'
            data={individualMeetingRoomsCardsData}
            title={areMeetingRoomsPresent ? undefined : `No meeting rooms details. Click add to enter the details`}
            actions={
              !areMeetingRoomsPresent || (areMeetingRoomsPresent && this.state.meetingRooms.length < FormConst.MAX_MEETING_ROOMS_COUNT)
                ? [{
                  'onClick': this.addMeetingRoom,
                  'label': '(+) Add Meeting Room'
                }]
                : undefined
            }
            footer={`You can add up to ${FormConst.MAX_MEETING_ROOMS_COUNT} meeting rooms`}
            isFill />
        </div>
        <FormFooter
          form={SideNavEntryMapping.MEETING_ROOMS}
          submitName={FormConst.SAVE_BUTTON_TEXT}
          onSubmit={this.saveMeetingRooms}
          noSubmit
          noReset />
        <FormModal
          id='meeting-rooms-page-loading-modal'
          title={FormConst.MODAL_UPDATE_ACTION_TITLE}
          hotelInfo={this.state.hotelInfo}
          body={<h5>{this.state.loadingMessage}</h5>}
          show={this.state.isLoading}
          isLoadingIndicator />
        <FormModal
          id='meeting-rooms-page-delete-modal'
          hotelInfo={this.state.hotelInfo}
          title='Delete Meeting Room'
          body={<h6>{FormConst.MODAL_DELETE_ACTION_TEXT}</h6>}
          proceed={this.deleteMeetingRoom}
          cancel={() => { this.setState({ showDeleteModal: false, deleteIndex: -1 }) }}
          show={this.state.showDeleteModal} />
        <FormModal
          id='meeting-rooms-page-error-modal'
          hotelInfo={this.state.hotelInfo}
          title={FormConst.MODAL_UPDATE_ACTION_ERROR_TITLE}
          body={<h5>{this.state.errorMessage}</h5>}
          isError
          cancel={() => { this.setState({ showErrorModal: false }) }}
          show={this.state.showErrorModal} />
      </div>
    )
  }
}

// Sample redux dispatch
const mapStateToProps = state => {
  return {
    meetingRoomsResponse: state.reducer.response,
    errorMessage: state.reducer.errorMessage,
    errorDescription: state.reducer.errorDescription,
    count: state.reducer.count
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onGet: (hotelCode) => dispatch(asyncMethod(FormConst.FORM_MEETING_ROOMS_NAME, actionTypes.ASYNC_ACTIONS.GET, { hotelCode: hotelCode })),
    onPut: (data) => dispatch(asyncMethod(FormConst.FORM_MEETING_ROOMS_NAME, actionTypes.ASYNC_ACTIONS.PUT, data))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withFormLayout(MeetingRooms, SideNavEntryMapping.MEETING_ROOMS))